<template>
  <div class="flex justify-center">
    <ButtonContentSection
      :label="contentSection.contentDescription || 'PDF'"
      :icon="PdfIcon"
      @click="openPDF"
    />
  </div>
</template>

<script>
import ButtonContentSection from "../layout/button/ButtonContentSection.vue";
import PdfIcon from "../icon/PdfIcon.vue";

export default {
  name: "PDFContentSection",
  components: {
    ButtonContentSection,
  },
  props: {
    contentSection: Object,
  },
  setup() {},
  computed: {
    PdfIcon() {
      return PdfIcon;
    },
  },
  methods: {
    openPDF() {
      window.open(this.contentSection.content, "_blank");
    },
  },
};
</script>

<style scoped></style>
